import { soundFx } from '../../lib/soundEffects'

export const Input = ({
  label,
  error,
  icon,
  className = '',
  onFocus,
  ...props
}) => {

  // Play error sound if error appears
  if (error) {
    // Small debounce could be nice, but for now simple
    // soundFx.play('error') // Misschien te irritant in render loop, beter bij submit
  }

  const handleFocus = (e) => {
    soundFx.play('focus')
    if (onFocus) onFocus(e)
  }

  return (
    <div className="w-full">
      {label && (
        <label className="block text-xs font-semibold uppercase tracking-wider text-gray-600 mb-2">
          {label}
        </label>
      )}

      <div className="relative">
        {icon && (
          <div className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400">
            {icon}
          </div>
        )}

        <input
          onFocus={handleFocus}
          className={`
            w-full px-4 py-3 ${icon ? 'pl-11' : ''}
            rounded-xl
            border border-white/20
            bg-white/12 backdrop-blur-sm
            text-gray-900 placeholder:text-gray-500/60
            shadow-sm
            transition-all duration-200
            focus:outline-none 
            focus:border-[var(--primary)]
            focus:bg-white/18
            focus:shadow-md
            focus:ring-4 focus:ring-[var(--primary)]/10
            hover:bg-white/15
            ${error ? 'border-red-400 focus:border-red-500 focus:ring-red-500/10' : ''}
            ${className}
          `.trim().replace(/\s+/g, ' ')}
          {...props}
        />
      </div>

      {error && (
        <p className="mt-2 text-sm text-red-600 flex items-center gap-1">
          <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
          </svg>
          {error}
        </p>
      )}
    </div>
  )
}
